import {
  Text,
  View,
  useWindowDimensions,
  ViewStyle,
  TextStyle,
} from 'react-native';
import React from 'react';
import {spacing} from 'theme/Units';
import {mergeDeepRight} from 'ramda';

type propType = Readonly<{
  links: {label: string; url: string; id: number}[];
  title: string;
}>;
export function HyperLinkSection(props: propType) {
  const {links, title} = props;

  const {width: SCREEN_WIDTH} = useWindowDimensions();
  let overrideStyle = structuredClone(baseStyles);

  if (SCREEN_WIDTH < 980) {
    overrideStyle.container.gap = spacing['2'];
    overrideStyle.title.marginBottom = spacing['1'];
  }
  if (SCREEN_WIDTH < 640) {
    overrideStyle.title.fontSize = 18;
    overrideStyle.label.fontSize = 16;
  }
  if (SCREEN_WIDTH < 480) {
    overrideStyle.title.fontSize = 16;
    overrideStyle.label.fontSize = 14;
  }

  const styles: styleType = mergeDeepRight(baseStyles, overrideStyle) as any;

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.container}>
        {links.map(item => {
          return (
            <Text style={styles.label} key={item.id}>
              {item.label}
            </Text>
          );
        })}
      </View>
    </View>
  );
}

type styleType = {
  container: ViewStyle;
  title: TextStyle;
  label: TextStyle;
};

let baseStyles: styleType = {
  container: {
    flex: 1,
    gap: spacing['4'],
  },
  title: {
    color: 'white',
    fontSize: 20,
    fontWeight: '700',
    marginBottom: 20,
  },
  label: {
    color: 'white',
    fontSize: 17,
    fontWeight: '400',
  },
};
